import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div", ...rest }) => {
  const C = motion[as];
  return (
    <C
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </C>
  );
};

const LINE = { hidden: { y: "110%" }, show: (i) => ({ y: "0%", transition: { duration: 1.1, delay: i, ease: EASE } }) };

export const MaskLines = ({ lines, className = "", lineClass = "", delay = 0.15, onView = false }) => {
  const trigger = onView ? { whileInView: "show", viewport: { once: true, amount: 0.1 } } : { animate: "show" };
  return (
    <motion.span className={`block ${className}`} initial="hidden" {...trigger}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
          <motion.span className={`block ${lineClass}`} variants={LINE} custom={delay + i * 0.12}>
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const Eyebrow = ({ children, light = false, className = "" }) => (
  <p className={`flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.22em] ${light ? "text-[#C9D4E1]" : "text-[#4A5D75]"} ${className}`}>
    <span className="h-px w-8 bg-[#C59B27]" aria-hidden="true" />
    {children}
  </p>
);
